import React from "react";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminProductsTranslation } from "../../translations";

const ProductsHeader = () => {
    const { language } = useLanguage();
    const { t } = useAdminProductsTranslation(language);

    return (
        <div className="admin-page-title">
            <h1>{t('products')}</h1>
            <p>{t('manageStoreProducts')}</p>
        </div>
    );
};

export default ProductsHeader;